import React from 'react';

import scheduleOrderImg from 'assets/images/schedule_order.webp';

import { formatScheduledBannerDate } from '../../domain';

import { useSOBannerDetailLang } from './hooks';

import makeClasses from './SOBannerDetail.style';

interface Props {
  placeAt: string;
}

export function SOBannerDetail({ placeAt }: Props) {
  const classes = makeClasses();
  const lang = useSOBannerDetailLang();

  const { date, time } = formatScheduledBannerDate(placeAt);

  return (
    <div className={classes.root}>
      <img
        src={scheduleOrderImg}
        alt=''
        className={classes.illustration}
        aria-hidden='true'
      />
      <p className={classes.bannerText}>{lang.getBannerText(date, time)}</p>
    </div>
  );
}
